import { LOGIN_MAPPED_ON_LIVE } from '../../constants';

export function loadJssoCrossWalk(onLoadCallback) {
  if (typeof window.jsso_js === 'undefined') {
    window.jsso_js = (function attachScript(d, myElement, id) {
      const t = window.jsso_js || {};
      if (d.getElementById(id)) return t;
      const js = d.createElement(myElement);
      js.id = id;
      js.src =
        LOGIN_MAPPED_ON_LIVE || __PROD__
          ? 'https://jssocdn.indiatimes.com/crosswalk_sdk/sdk/jsso_crosswalk_legacy_0.7.995.min.js'
          : 'https://jssocdn.indiatimes.com/crosswalk_sdk/sdk/jsso_crosswalk_legacy_0.7.995.min.js';

      if (typeof onLoadCallback === 'function') {
        js.addEventListener('load', onLoadCallback, false);
      }
      setTimeout(() => {
        const fjs = d.getElementsByTagName(myElement)[0];
        const parent = fjs?.parentNode || d.head;
        parent.insertBefore(js, fjs);
      }, 0);

      t._e = [];
      t.ready = f => {
        t._e.push(f);
      };

      return t;
    })(document, 'script', 'jsso-crosswalk-js');
  } else if (typeof onLoadCallback === 'function') {
    onLoadCallback();
  }
}

export default loadJssoCrossWalk;
